<template>
    <div>
        <file-preview :overlay.sync="overlay" :file="file" />
        <v-data-table
            calculate-widths
            :multi-sort="setup.pagination.multiSort"
            :loading="setup.loading"
            :headers="setup.headers"
            :items="setup.items"
            :server-items-length="setup.totalItems"
            :options.sync="setup.pagination"
            :footer-props="setup.footerProps"
            :loading-text="$t('common.dataTable.loadingText')"
            :no-data-text="$t('common.dataTable.noDataText')"
            @click:row="rowCtrlClicked"
        >
            <template v-for="(column, index) in setup.headers" #[`item.${column.value}`]="{ item }">
                <template functional v-if="column.filePreview && item[column.value]" data-action="filePreview">
                    <v-btn
                        :key="index"
                        :ref="`${column.value}${item['objectId']}`"
                        elevation="0"
                        small
                        plain
                        @click="openFilePreview(item)"
                        data-action="filePreview"
                    >
                        {{ $t('common.dataTable.view') }}
                        <v-icon
                            class="dont-click ml-1"
                            dark
                        >
                            visibility
                        </v-icon>
                    </v-btn>
                </template>

                <template functional v-else-if="column.date">
                    <span :key="index" :ref="`${column.value}${item['objectId']}`">{{ item[column.value] | momentFormatDate("L") }}</span>
                </template>

                <template functional v-else-if="column.html">
                    <div class="resume" :key="index" v-html="getResume(item[column.value])"></div>
                </template>

                <template functional v-else>
                    <span :key="index" v-html="$helpers.getObjectValueByPath(item, column.value)"></span>
                </template>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-btn
                    v-if="actionDeleteIsEnabled"
                    class="ma-1"
                    depressed
                    outlined
                    icon
                    fab
                    dark
                    color="pink"
                    small
                    @click="deleteItem(item)"
                    data-action="delete"
                >
                    <v-icon
                        class="dont-click"
                    >
                        delete
                    </v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <modal-corporate-historic :drawer.sync="drawer" :loading="setup.loading" :is-edit="true" :corporate-historic-detail="act" @close-corporate-historic-success-dialog="loadData()"></modal-corporate-historic>
    </div>
</template>

<script>
import ModalCorporateHistoric from '@/components/corporate/ModalCorporateHistoric'
import FilePreview from '@/components/FilePreview'

export default {
    name: 'datatable-corporate-historic',
    props: ['setup'],
    components: {
        ModalCorporateHistoric,
        FilePreview
    },
    data () {
        return {
            drawer: null,
            overlay: null,
            enabled: null,
            act: undefined,
            file: null
        }
    },
    computed: {
        actionEditIsEnabled () {
            let header = this.setup.headers.find(x => x.value === 'actions')
            return header.edit
        },
        actionDeleteIsEnabled () {
            let header = this.setup.headers.find(x => x.value === 'actions')
            return header.delete
        }
    },
    watch: {
        'setup.pagination': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.formatSort()
                    this.$emit('update:setup', this.setup)
                }
            },
            deep: true
        },
        'setup.loading': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (!val) {
                        this.paintCell()
                    } else {
                        this.setup.items = []
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        formatSort () {
            this.setup.pagination.sortFormated = this.setup.pagination.sortBy.map((sort, index) => {
                let valueSort = sort.split('.')
                return { value: valueSort[0], descending: this.setup.pagination.sortDesc[index] }
            })
        },
        avatarColor (item) {
            return (item.color) ? item.color : 'white'
        },
        deleteItem (item) {
            if (confirm(`${this.$t('common.dataTable.deleteConfirm')} ${this.setup.itemName}?`)) {
                this.$emit('delete-item', item)
            }
        },
        openFilePreview (item) {
            this.file = item.file
            this.overlay = true
        },
        rowCtrlClicked (item) {
            if (
                event.target.dataset.action !== 'filePreview' &&
                event.target.offsetParent.dataset.action !== 'filePreview' &&
                event.target.dataset.action !== 'delete' &&
                event.target.offsetParent.dataset.action !== 'delete'
            ) {
                this.act = item
                this.drawer = true
            }
        },
        async paintCell () {
            await this.$helpers.sleep(0)
            let cells = document.getElementsByClassName('has-background')
            if (cells.length > 0) {
                for (let index = 0; index < cells.length; index++) {
                    let father = cells[index].parentElement
                    father.setAttribute('style', 'background-color: ' + cells[index].getAttribute('data-color'))
                }
            }
        },
        async lateDeadline (element, column, value) {
            await this.$helpers.sleep(0)
            let isLateClass = ''
            if (column === 'deadlineDate') {
                if (value !== undefined) {
                    if (new Date(value.iso) < new Date()) {
                        let father = this.$refs[element][0].parentElement
                        let grandFather = father.parentElement
                        grandFather.setAttribute('class', 'row-clickable')
                        father.setAttribute('style', 'color: rgba(255, 0, 0, 1); background-color: rgba(255, 0, 0, 0.2);')
                        isLateClass = 'isLate'
                    }
                }
            }
            return isLateClass
        },
        loadData () {
            this.$emit('load-data')
        },
        getResume (text) {
            text = text.replace(/<[^>]*>?/gm, '  ')
            text = text.substring(0, 130)
            return `${text}...`
        }
    }
}
</script>

<style lang="sass">
    .late-deadline
        color: white
        background-color: red

    .tr-clickable
        tbody
            tr
                cursor: pointer

    .row-clickable
        cursor: pointer

    .dont-click
        pointer-events: none
</style>
